<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { myAccount } from '@consumer/api'
import { useSharedData } from '@consumer/composables/sharedData'
import { useFavoritesStore } from '@consumer/services/favorites/store'
import { asyncOpenModal } from '@consumer/services/modals'
import newMiscNoFavoritesIcon from '@consumer/assets/icons/new-misc/no-favorites.svg?svgicon'
import Favorite from './Favorite.vue'

const __$temp_1 = (useFavoritesStore()),
  isEmpty = _toRef(__$temp_1, 'isEmpty'),
  isLoading = _toRef(__$temp_1, 'isLoading'),
  recentlyAddedFavorites = _toRef(__$temp_1, 'recentlyAddedFavorites');
const __$temp_2 = (useSharedData()),
  currentUser = _toRef(__$temp_2, 'currentUser');

async function openLoginOrSignupModal () {
  await asyncOpenModal(import('@consumer/modals/loginOrSignup/LoginOrSignUpModal.vue'))
}
</script>

<template>
  <div class="favorites-dropdown flex flex-col gap-3 lg:mt-3">
    <div
      v-if="isEmpty && !isLoading"
      class="flex flex-col items-center text-center text-base font-medium"
    >
      <GIcon :svg="newMiscNoFavoritesIcon" size="220px" class="stroke-4 text-grey-500" style="height: 160px;"/>
    </div>

    <div
      v-if="isLoading"
      class="flex flex-col items-center justify-center h-56"
    >
      <LoadingIndicator/>
    </div>

    <template v-else>
      <Favorite v-for="favorite in recentlyAddedFavorites" :key="favorite.id" :favorite="favorite"/>
    </template>

    <div v-if="!isEmpty && !isLoading">
      <GButton v-if="currentUser" :href="myAccount.favorites.path()" secondary label="View all favorites"/>
      <div v-else class="text-sm text-v2-tertiary">
        <span>
          To save favorites and create lists
        </span>
        <GButton flat primary @click="openLoginOrSignupModal">Log in</GButton>
        <span> or </span>
        <GButton flat primary @click="openLoginOrSignupModal">Sign up</GButton>
      </div>
    </div>
  </div>
</template>
